import React, { useState, useEffect } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import drEasyApi from "../../../Api/Customapi";
import { getImg } from "../../../Api/getImg";

const ImageUploader = ({ 
  form, 
  value, 
  onChange, 
  spec = false, 
  multiple = false 
}) => {
  const [uploading, setUploading] = useState(false);
  const [previewIds, setPreviewIds] = useState([]);

  // Initialize preview IDs from value prop
  useEffect(() => {
    if (multiple && Array.isArray(value)) {
      setPreviewIds(value);
    } else if (!multiple && value) {
      setPreviewIds([value]);
    } else {
      setPreviewIds([]);
    }
  }, [value, multiple]);

  const handleUpload = async ({ file, onSuccess, onError }) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await drEasyApi.post("/api/Storage/UploadImage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const imageId = res.data.id;

      if (multiple) {
        const newIds = [...previewIds, imageId];
        setPreviewIds(newIds);
        if (onChange) onChange(newIds);
        if (form) {
          spec
            ? form.setFieldsValue({ photoId: newIds })
            : form.setFieldsValue({ photoID: newIds });
        }
      } else {
        setPreviewIds([imageId]);
        if (onChange) onChange(imageId);
        if (form) {
          spec
            ? form.setFieldsValue({ photoId: imageId })
            : form.setFieldsValue({ photoID: imageId });
        }
      }

      message.success("Image uploaded successfully");
      onSuccess?.();
    } catch (err) {
      message.error("Failed to upload image");
      console.error("Upload error:", err);
      onError?.(err);
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = (imageIdToRemove) => {
    if (multiple) {
      const newIds = previewIds.filter(id => id !== imageIdToRemove);
      setPreviewIds(newIds);
      if (onChange) onChange(newIds);
      if (form) {
        spec
          ? form.setFieldsValue({ photoId: newIds })
          : form.setFieldsValue({ photoID: newIds });
      }
    } else {
      setPreviewIds([]);
      if (onChange) onChange(null);
      if (form) {
        spec
          ? form.setFieldsValue({ photoId: null })
          : form.setFieldsValue({ photoID: null });
      }
    }
    message.success("Image removed");
  };

  return (
    <div>
      <Upload
        name="file"
        showUploadList={false}
        customRequest={handleUpload}
        accept=".jpg,.jpeg,.png,.gif,.webp"
        disabled={uploading}
      >
        <Button 
          icon={<UploadOutlined />} 
          loading={uploading}
          disabled={uploading}
        >
          {uploading ? "Uploading..." : "Upload Image"}
        </Button>
      </Upload>

      {previewIds.length > 0 && (
        <div className={`mt-3 ${multiple ? 'flex flex-wrap gap-2' : ''}`}>
          {previewIds.map((imageId, index) => (
            <div key={imageId || index} className="relative inline-block">
              <img
                src={getImg(imageId)}
                alt={`Preview ${index + 1}`}
                className="rounded object-cover border"
                style={{ width: 130, height: 130 }}
                onError={(e) => {
                  console.error("Image failed to load:", imageId);
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23ddd' width='100' height='100'/%3E%3Ctext x='50%25' y='50%25' font-size='14' text-anchor='middle' dy='.3em' fill='%23999'%3EError%3C/text%3E%3C/svg%3E";
                }}
              />
              <button
                onClick={() => handleRemoveImage(imageId)}
                className="absolute top-1 right-1 bg-red-500 text-white rounded-full px-1 hover:bg-red-600 transition-colors"
                title="Remove image"
                type="button"
              >
                <DeleteOutlined style={{ fontSize: '14px' }} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUploader;